import {RouteRecordRaw} from "vue-router";

const routes: Array<RouteRecordRaw> = [
];

export default routes;